<template>
  <div>
    <div class="no-demand" v-show="noDemand" v-loading="tableLoading">
      <i class="el-icon-document-add"></i>
      <div class="msg">这里可以解决的产品及服务问题</div>
      <el-button class="btn" type="primary" @click="clickAddDemand"
        >提一个需求</el-button
      >
    </div>
    <div class="conent" v-show="!noDemand">
      <div class="tabs">
        <div class="tabs-content">
          <div
            v-for="(item, index) in tabs"
            :key="item.name"
            :class="['tab', { clicked: item.selected }]"
            @click="clickTabs(index)"
          >
            {{ item.name
            }}<span v-if="item.num > 0"
              >(<span class="tab-num">{{ item.num }}</span
              >)</span
            >
          </div>
          <div class="btn">
            <el-button
              icon="el-icon-plus"
              type="primary"
              @click="clickAddDemand"
              >提需求</el-button
            >
          </div>
        </div>
      </div>
      <div class="search">
        <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="getDataList(1)"
          @submit.native.prevent
          label-width="100px"
        >
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="单据编号：" prop="demandCode">
                <el-input
                  v-model="dataForm.demandCode"
                  placeholder="请输入单据编号"
                  clearable
                  style="width: 240px"
                ></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item label="提交时间：" prop="equipmentType">
                <el-date-picker
                  v-model="dataForm.subDate"
                  :picker-options="pickerOptions"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 240px"
                >
                </el-date-picker>
                <!-- <el-input v-model="dataForm.equipmentType" placeholder="请输入设备类别" clearable style="width:210px;"></el-input> -->
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but" @click="getDataList(1)">查询</button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="table">
        <el-table
          :data="dataList"
          border
          @selection-change="selectionChangeHandle"
          v-loading="tableLoading"
        >
          <el-table-column
            type="index"
            header-align="center"
            align="center"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="demandCode"
            header-align="center"
            align="center"
            label="单据编号"
            width="110"
          ></el-table-column>
          <el-table-column
            prop="demandDescribe"
            header-align="center"
            align="center"
            label="需求描述"
          >
            <template slot-scope="scope">
              <el-tooltip placement="bottom">
                <div slot="content" class="tip">
                  {{ scope.row.demandDescribe }}
                </div>
                <div class="demand-desc overell">
                  {{ scope.row.demandDescribe }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            label="提交时间"
            :formatter="(row, column, value) => formatDate(value)"
            width="100px"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            header-align="center"
            align="center"
            label="受理人"
          ></el-table-column>
          <el-table-column
            prop="mobile"
            header-align="center"
            align="center"
            label="受理人联系方式"
          ></el-table-column>
          <el-table-column
            prop="status"
            header-align="center"
            align="center"
            label="单据状态"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.status === 0
                "
                >待受理</span
              >
              <span
                v-else-if="
                  scope.row.status === 1
                "
                >处理中</span
              >
              <!-- <span v-else-if="scope.row.status===1">待领受</span> -->
              <span v-else-if="scope.row.status === 2" style="color: red"
                >待评价</span
              >
              <span
                v-else-if="
                  scope.row.status === 3
                "
                >已完成</span
              >
              <span
                v-else-if="
                  scope.row.status === 4
                "
                >已撤销</span
              >
              <span
                v-else-if="
                  scope.row.status === 5
                "
                >已关闭</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="80px"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="addOrUpdateHandle(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/validate'
export default {
  name: 'demandList', // 需求派单
  data () {
    return {
      tabs: [
        {
          name: '全部',
          num: 0,
          selected: true,
          keys: null,
          id: ''
        },
        {
          name: '待受理',
          num: 0,
          selected: false,
          keys: 0,
          id: 'PENDING'
        },
        {
          name: '处理中',
          num: 0,
          selected: false,
          keys: 1,
          id: 'PROCESSING'
        },
        {
          name: '待评价',
          num: 0,
          selected: false,
          keys: 2,
          id: 'COMMENT'
        },
        {
          name: '已完成',
          num: 0,
          selected: false,
          keys: 3,
          id: 'COMPLETED'
        },
        // {
        //   name: '已撤销',
        //   num: 0,
        //   selected: false,
        //   keys: 4
        // },
        {
          name: '已关闭',
          num: 0,
          selected: false,
          keys: 5
        }
      ],
      tableLoading: false,
      formatDate,
      dataList: [],
      page: {
        sizes: [10, 20, 50, 100],
        size: 10,
        current: 1,
        total: 0
      },
      dataForm: {
        demandCode: '',
        subDate: [],
        demandStatus: '',
        createTimeStart: '',
        createTimeEnd: '',
        companyId: this.$store.state.user.defaultCompanyId
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() >= Date.now()
        }
      },
      noDemand: true
    }
  },
  methods: {
    getDataList (currentPage = this.page.current) {
      this.tableLoading = true
      let demandStatus = this.tabs.filter((item) => {
        return item.selected
      })[0].keys
      let startTime, endTime
      if (!this.dataForm.subDate || !this.dataForm.subDate.length) {
        startTime = ''
        endTime = ''
      } else {
        startTime = this.dataForm.subDate[0] + ' 00:00:00'
        endTime = this.dataForm.subDate[1] + ' 23:59:59'
      }
      this.$http
        .post(
          `${window.SITE_CONFIG['apiURL']}/front/consumer/demand/demandList`,
          {
            page: this.page.current,
            limit: this.page.size,
            demandCode: this.dataForm.demandCode,
            companyId: this.$store.state.user.defaultCompanyId,
            createTimeStart: startTime,
            createTimeEnd: endTime,
            status: demandStatus
          }
        )
        .then(({ data }) => {
          if (data && data.data && data.code === 0) {
            this.dataList = data.data.data || []
            if (this.dataList.length > 0) {
              this.noDemand = false
            }
            this.page.total = data.data.count
            // this.page.current = data.data.currentPage
          } else {
            this.noDemand = false
            this.dataList = []
            this.page.total = 0
            // this.page.current = 1
            this.$message.error(data.result.msg)
          }
          this.tableLoading = false
        })
        .catch(() => {
          this.dataList = []
          this.noDemand = false
          this.tableLoading = false
          // this.$message.error(err.message || '获取数据失败')
        })
    },
    getStatusCount () {
      let params = {
        companyId: this.$store.state.user.defaultCompanyId
      }
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/consumer/demand/customer/status`, { params })
        .then(({ data }) => {
          if (data && data.data && data.code === 0) {
            this.tabs.map(item => {
              if (Object.keys(data.data).includes(item.id)) {
                item.num = data.data[item.id]
              }
            })
          }
        })
        .catch(() => {
        })
    },
    // 切换状态
    clickTabs (i) {
      this.tabs.map((item) => {
        item.selected = false
      })
      this.tabs[i].selected = true
      this.getDataList(1)
    },
    selectionChangeHandle () {},
    // 跳转详情
    addOrUpdateHandle (row) {
      this.$router.push({ name: 'demandDetail', query: { id: row.demandServiceId } })
    },
    clickAddDemand () {
      if (this.$store.state.user.defaultCompanyAuthentFlag === '40') {
        this.$router.push({ name: 'addDemand' })
      } else {
        this.$confirm('您的企业还未认证，认证后享在线极速派单服务', '提示', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
            name: 'enterpriseCertification',
            query: {
              cId: this.$store.state.user.defaultCompanyId
            }
          })
        }).catch(() => {
        })
      }
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getDataList()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getDataList()
    },
    reset () {
      this.dataForm.demandCode = ''
      this.dataForm.typingPerson = ''
      this.dataForm.subDate = ''
      this.dataForm.createTimeStart = ''
      this.dataForm.createTimeEnd = ''
    }
  },
  activated () {
    this.getDataList()
    this.getStatusCount()
  },
  mounted () {
    this.getDataList()
    this.getStatusCount()
  }
}
</script>

<style lang="scss" scoped>
.conent {
  .tabs {
    height: 60px;
    background: #efefef;
    margin: 0 0 20px 0;
    .tabs-content {
      .tab {
        display: inline-block;
        width: 120px;
        line-height: 60px;
        text-align: center;
        cursor: pointer;
        .tab-num {
          color: #fe2d46;
        }
      }
      .tab.clicked {
        background: #e6e5e5;
        height: 60px;
        border-bottom: 2px solid #4a84b9;
      }
      .btn {
        float: right;
        margin: 10px 10px 0 0;
      }
    }
  }
  .search {
    .search-row {
      display: flex;
    }
    .search-conent {
      min-width: 350px;
      margin-right: 20px;
    }
    .search-but {
      width: 100%;
      /* min-width: 200px; */
      text-align: right;
    }
    .info-but {
      background: #ffffff;
      width: 96px;
      height: 40px;
      text-align: center;
      line-height: 38px;
      font-size: 14px;
      color: #1d65a8;
      letter-spacing: 0;
      border: none;
      cursor: pointer;
      user-select: none;
      border: 1px solid #1d65a8;
      margin-right: 10px;
    }
    .info-but:hover {
      background: #1d65a8;
      color: #ffffff;
    }
    .info-but-new {
      background: #1d65a8;
      color: #ffffff;
    }
  }
}
.no-demand {
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  margin-top: 100px;
  .el-icon-document-add {
    font-size: 60px;
  }
  .msg {
    font-size: 12px;
    color: #ccc;
    margin: 20px 0 30px 0;
  }
  .btn {
    font-size: 16px;
  }
}
</style>
